<template>
 <div id="ContainerPatientAsam">
  <Asam v-bind:PatientCode="this.$route.params.id"/>
</div>

</template>

<script>
import Asam from "@/components/asam/Asam";
import EnumService from '@/services/enum.service'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {

  /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iUA = await vm.$store.state.isUseASAM;
            if(iUA) next()
            else next('/accessdenied');
        }) 
  },*/
  mixins: [Permission],
  components: { Asam },
  data() {
    return {
      OptionsRightMenu:{
			visible:true,
			ItemsList:[],
			btnvisible:true,
      itemdisabled: false,
      allowAccess: false,
      isUseAsam: false
		}
    }
  },
 
methods:{
    MenuVisible(){
        this.OptionsRightMenu.visible = true; 
        this.OptionsRightMenu.btnvisible = true;      
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointments-asam') ? EnumService.AppointmentItems : EnumService.PatientItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu); 
    },
},

created(){    
    this.InitializePermissions('ListView', this.$store.state.isUseASAM);
},

  mounted() {
    if (!this.IsAccessAllowed()) {
        return;
    }
    
    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
   this.MenuVisible();
  },
  
  updated(){
  this.MenuVisible();
  },
  destroyed(){
     this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
  }
}

</script>





